<template>
  <div
    id="app"
    :style="'background: #1797c0 url(' + commonGradientBody + ') repeat-x'"
  >
    <!-- 全局加载动画 -->
    <div v-if="isLoading" class="global-loading">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import commonGradientBody from "@/assets/gradient_body.png";

export default {
  name: "App",
  data() {
    return {
      commonGradientBody, 
    };
  },
  computed: {
    ...mapGetters(["isLoading"]),
    
  },
  mounted() {
    this.checkTokenOnNewWindow();
  },
  methods: {
    checkTokenOnNewWindow() {
      const token = localStorage.getItem("token");
      if (token) {
        console.log("token", token);
        return true;
      }
      // 如果没有 token 且当前不是登录页，则跳转到登录页
      // else if (this.$route.path !== "/login") {
      //   this.$router.push("/login");
      // }
    },
  },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  margin-top: 10px;
  color: #2c3e50;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 全局加载动画样式 */
.global-loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
}

.loading-spinner {
  width: 50px;
  height: 50px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(23, 151, 192, 0.3);
  border-top-color: #1797c0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>